import { filter, fromEvent, map, partition } from 'rxjs';

import { redirectToSearchCommunityResults } from '../../components/redirectHandler';

const searchSubmitElement = document.querySelector('[data-search-submit]');
const searchInput = document.getElementById('blog_typeahead_input');
const searchForm = searchInput.closest('form');

/**
 * displayErrorContainer: Opens the error container messages.
 */
const displayErrorContainer = function () {
    const errorContainer = document.getElementById('blog_typeahead_error');
    const form = errorContainer.closest('form');
    const errorContainers = errorContainer.parentElement.querySelectorAll('[data-typeahead-error]');
  
    errorContainers.forEach((container) => { container.style.display = 'none'});
    form.classList.add('error');
    errorContainer.style.display = 'block';
  }
  
  /**
   * Observable to validate if the search text is wrong to show error message or perform redirects
   */
  const searchSubmit$ = fromEvent(searchSubmitElement, 'click').pipe(
    filter(event => event.target?.matches('[data-search-submit]')),
    map(() => document.getElementById('blog_typeahead_input').value.trim())
  );
  
  const [submitSearchText$, displayError$] = partition(
    searchSubmit$,
    (searchValue) => searchValue
  );
  
  submitSearchText$.subscribe(redirectToSearchCommunityResults);
  displayError$.subscribe(displayErrorContainer);
  
  
  /**
   * closeErrorContainer: Closes the error container messages.
   */
  const closeErrorContainer = function () {
    const errorContainer = document.getElementById('blog_typeahead_error');
    const form = errorContainer.closest('form');
    const errorContainers = errorContainer.parentElement.querySelectorAll('[data-typeahead-error]');
  
    errorContainers.forEach((container) => { container.style.display = 'none'});
    form.classList.remove('error');
    errorContainer.style.display = 'none';
  };
  
  const formOutClick$ = fromEvent(document, 'click').pipe(filter((event) =>  (
    !event.target.matches('[data-search-submit]') && !searchForm.contains(event.target))));
  formOutClick$.subscribe(closeErrorContainer);